@if (content) {
  <app-layout-default>
    <app-contact-us [content]="getContactUsByAccountType()"></app-contact-us>
    <app-checklist>
      <h2 data-cy="checkListHeading" id="checklistHeading" class="c11n-text-lg" [innerHTML]="content.checklistHeading">
      </h2>
      <p data-cy="checkListDesc" class="c11n-text-md" [innerHTML]="content.checklistDesc"></p>
    </app-checklist>
    <app-additional-info [heading]="content.additionalInfoHeading" [content]="getAdditionalInfoByAccountType()">
    </app-additional-info>
    <div layout-last-column>
      <c11n-button id="ineligibleBTN" (clickEvent)="learnMore()" [labelText]="content.buttonLabel" fullWidth="true">
      </c11n-button>
      <app-feedback-survey></app-feedback-survey>
    </div>
  </app-layout-default>
}
